import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  IconButton,
  Tooltip,
  Paper,
} from '@material-ui/core';
import { Refresh } from '@material-ui/icons';

// Import both dashboard components
import AdminTrainingDashboard from './AdminTrainingDashboard';
import ModernTrainingDashboard from './ModernTrainingDashboard';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    minHeight: '100vh',
  },
  header: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  modernContainer: {
    '& .MuiPaper-root': {
      transition: 'all 0.3s ease-in-out',
    },
  },
  classicContainer: {
    backgroundColor: theme.palette.background.default,
  },
}));

const TrainingDashboardSwitch = ({
  isLoading,
  accessLevel,
  selectedClient,
  defaultClient,
  history,
  location,
  getTranslation,
  preferredLanguage,
  trainingData,
  adminTrainingData,
  userClickOverviewData,
  onRefresh,
}) => {
  const classes = useStyles();
  const [viewMode, setViewMode] = useState('modern'); // Default to modern view
  const [refreshTime, setRefreshTime] = useState(new Date());

  const handleViewModeChange = (event) => {
    setViewMode(event.target.value);
  };

  const handleManualRefresh = () => {
    setRefreshTime(new Date());
    if (onRefresh) {
      onRefresh();
    }
  };

  // If we don't have training admin data, fall back to classic view
  const hasTrainingData = adminTrainingData && 
    (adminTrainingData.getClientTrainingStats || adminTrainingData.getUserLevelTrainingStats);

  return (
    <div className={classes.root}>

      {/* Dashboard Content */}
      <Box className={viewMode === 'modern' ? classes.modernContainer : classes.classicContainer}>
        {viewMode === 'modern' && hasTrainingData ? (
          <ModernTrainingDashboard
            isLoading={isLoading}
            adminTrainingData={adminTrainingData}
            userClickOverviewData={userClickOverviewData}
            getTranslation={getTranslation}
            preferredLanguage={preferredLanguage}
            onRefresh={handleManualRefresh}
            viewMode={viewMode}
            onViewModeChange={handleViewModeChange}
            refreshTime={refreshTime}
            trainingData={trainingData}
            accessLevel={accessLevel}
            selectedClient={selectedClient}
          />
        ) : (
          <AdminTrainingDashboard
            isLoading={isLoading}
            accessLevel={accessLevel}
            selectedClient={selectedClient}
            defaultClient={defaultClient}
            history={history}
            location={location}
            getTranslation={getTranslation}
            preferredLanguage={preferredLanguage}
            trainingData={trainingData}
            adminTrainingData={adminTrainingData}
          />
        )}
      </Box>
    </div>
  );
};

export default TrainingDashboardSwitch;